export default __webpack_public_path__ + "static/video-hero-6e65ca03b8a00aaf2a22bcad6f2a18f8.svg";